/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CountryCode,
  CreatePaymentMethodCountryConnectionRequest,
  CreatePaymentMethodLocationConnectionRequest,
  CreatePaymentMethodRequest,
  EnsurePaymentMethodForLocationRequest,
  ErrorMessage,
  LocationSearchDto,
  PaymentMethodCountryConnectionDto,
  PaymentMethodCountryDto,
  PaymentMethodDetailsDto,
  PaymentMethodDto,
  PaymentMethodLocationConnectionDto,
  PaymentMethodLocationDto,
  PaymentProvider,
} from '../models/index';
import {
    CountryCodeFromJSON,
    CountryCodeToJSON,
    CreatePaymentMethodCountryConnectionRequestFromJSON,
    CreatePaymentMethodCountryConnectionRequestToJSON,
    CreatePaymentMethodLocationConnectionRequestFromJSON,
    CreatePaymentMethodLocationConnectionRequestToJSON,
    CreatePaymentMethodRequestFromJSON,
    CreatePaymentMethodRequestToJSON,
    EnsurePaymentMethodForLocationRequestFromJSON,
    EnsurePaymentMethodForLocationRequestToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    LocationSearchDtoFromJSON,
    LocationSearchDtoToJSON,
    PaymentMethodCountryConnectionDtoFromJSON,
    PaymentMethodCountryConnectionDtoToJSON,
    PaymentMethodCountryDtoFromJSON,
    PaymentMethodCountryDtoToJSON,
    PaymentMethodDetailsDtoFromJSON,
    PaymentMethodDetailsDtoToJSON,
    PaymentMethodDtoFromJSON,
    PaymentMethodDtoToJSON,
    PaymentMethodLocationConnectionDtoFromJSON,
    PaymentMethodLocationConnectionDtoToJSON,
    PaymentMethodLocationDtoFromJSON,
    PaymentMethodLocationDtoToJSON,
    PaymentProviderFromJSON,
    PaymentProviderToJSON,
} from '../models/index';

export interface CreatePaymentMethodOperationRequest {
    createPaymentMethodRequest: CreatePaymentMethodRequest;
}

export interface CreatePaymentMethodCountryConnectionOperationRequest {
    paymentProvider: PaymentProvider;
    paymentMethod: string;
    createPaymentMethodCountryConnectionRequest: CreatePaymentMethodCountryConnectionRequest;
}

export interface CreatePaymentMethodLocationConnectionOperationRequest {
    paymentProvider: PaymentProvider;
    paymentMethod: string;
    createPaymentMethodLocationConnectionRequest: CreatePaymentMethodLocationConnectionRequest;
}

export interface DeactivatePaymentMethodForLocationRequest {
    locationId: number;
    paymentProvider: PaymentProvider;
    paymentMethod: string;
}

export interface EnsurePaymentMethodForLocation1Request {
    locationId: number;
    paymentProvider: PaymentProvider;
    paymentMethod: string;
    ensurePaymentMethodForLocationRequest: EnsurePaymentMethodForLocationRequest;
}

export interface GetPaymentMethodCountriesRequest {
    paymentProvider: PaymentProvider;
    paymentMethod: string;
}

export interface GetPaymentMethodCountryConnectionsRequest {
    paymentProvider: PaymentProvider;
    paymentMethod: string;
    countryCode?: CountryCode;
}

export interface GetPaymentMethodDetailsRequest {
    paymentProvider: PaymentProvider;
    paymentMethod: string;
}

export interface GetPaymentMethodLocationConnectionsRequest {
    paymentProvider: PaymentProvider;
    paymentMethod: string;
    locationId?: number;
}

export interface GetPaymentMethodLocationsRequest {
    paymentProvider: PaymentProvider;
    paymentMethod: string;
}

/**
 * 
 */
export class PaymentMethodControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for createPaymentMethod without sending the request
     */
    async createPaymentMethodRequestOpts(requestParameters: CreatePaymentMethodOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createPaymentMethodRequest'] == null) {
            throw new runtime.RequiredError(
                'createPaymentMethodRequest',
                'Required parameter "createPaymentMethodRequest" was null or undefined when calling createPaymentMethod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-methods`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePaymentMethodRequestToJSON(requestParameters['createPaymentMethodRequest']),
        };
    }

    /**
     */
    async createPaymentMethodRaw(requestParameters: CreatePaymentMethodOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createPaymentMethodRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createPaymentMethod(requestParameters: CreatePaymentMethodOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPaymentMethodRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for createPaymentMethodCountryConnection without sending the request
     */
    async createPaymentMethodCountryConnectionRequestOpts(requestParameters: CreatePaymentMethodCountryConnectionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentProvider'] == null) {
            throw new runtime.RequiredError(
                'paymentProvider',
                'Required parameter "paymentProvider" was null or undefined when calling createPaymentMethodCountryConnection().'
            );
        }

        if (requestParameters['paymentMethod'] == null) {
            throw new runtime.RequiredError(
                'paymentMethod',
                'Required parameter "paymentMethod" was null or undefined when calling createPaymentMethodCountryConnection().'
            );
        }

        if (requestParameters['createPaymentMethodCountryConnectionRequest'] == null) {
            throw new runtime.RequiredError(
                'createPaymentMethodCountryConnectionRequest',
                'Required parameter "createPaymentMethodCountryConnectionRequest" was null or undefined when calling createPaymentMethodCountryConnection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-methods/{paymentProvider}/{paymentMethod}/country-connections`;
        urlPath = urlPath.replace(`{${"paymentProvider"}}`, encodeURIComponent(String(requestParameters['paymentProvider'])));
        urlPath = urlPath.replace(`{${"paymentMethod"}}`, encodeURIComponent(String(requestParameters['paymentMethod'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePaymentMethodCountryConnectionRequestToJSON(requestParameters['createPaymentMethodCountryConnectionRequest']),
        };
    }

    /**
     */
    async createPaymentMethodCountryConnectionRaw(requestParameters: CreatePaymentMethodCountryConnectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentMethodCountryConnectionDto>> {
        const requestOptions = await this.createPaymentMethodCountryConnectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentMethodCountryConnectionDtoFromJSON(jsonValue));
    }

    /**
     */
    async createPaymentMethodCountryConnection(requestParameters: CreatePaymentMethodCountryConnectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentMethodCountryConnectionDto> {
        const response = await this.createPaymentMethodCountryConnectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createPaymentMethodLocationConnection without sending the request
     */
    async createPaymentMethodLocationConnectionRequestOpts(requestParameters: CreatePaymentMethodLocationConnectionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentProvider'] == null) {
            throw new runtime.RequiredError(
                'paymentProvider',
                'Required parameter "paymentProvider" was null or undefined when calling createPaymentMethodLocationConnection().'
            );
        }

        if (requestParameters['paymentMethod'] == null) {
            throw new runtime.RequiredError(
                'paymentMethod',
                'Required parameter "paymentMethod" was null or undefined when calling createPaymentMethodLocationConnection().'
            );
        }

        if (requestParameters['createPaymentMethodLocationConnectionRequest'] == null) {
            throw new runtime.RequiredError(
                'createPaymentMethodLocationConnectionRequest',
                'Required parameter "createPaymentMethodLocationConnectionRequest" was null or undefined when calling createPaymentMethodLocationConnection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-methods/{paymentProvider}/{paymentMethod}/location-connections`;
        urlPath = urlPath.replace(`{${"paymentProvider"}}`, encodeURIComponent(String(requestParameters['paymentProvider'])));
        urlPath = urlPath.replace(`{${"paymentMethod"}}`, encodeURIComponent(String(requestParameters['paymentMethod'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePaymentMethodLocationConnectionRequestToJSON(requestParameters['createPaymentMethodLocationConnectionRequest']),
        };
    }

    /**
     */
    async createPaymentMethodLocationConnectionRaw(requestParameters: CreatePaymentMethodLocationConnectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createPaymentMethodLocationConnectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createPaymentMethodLocationConnection(requestParameters: CreatePaymentMethodLocationConnectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPaymentMethodLocationConnectionRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deactivatePaymentMethodForLocation without sending the request
     */
    async deactivatePaymentMethodForLocationRequestOpts(requestParameters: DeactivatePaymentMethodForLocationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling deactivatePaymentMethodForLocation().'
            );
        }

        if (requestParameters['paymentProvider'] == null) {
            throw new runtime.RequiredError(
                'paymentProvider',
                'Required parameter "paymentProvider" was null or undefined when calling deactivatePaymentMethodForLocation().'
            );
        }

        if (requestParameters['paymentMethod'] == null) {
            throw new runtime.RequiredError(
                'paymentMethod',
                'Required parameter "paymentMethod" was null or undefined when calling deactivatePaymentMethodForLocation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/payment-methods/{paymentProvider}/{paymentMethod}`;
        urlPath = urlPath.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters['locationId'])));
        urlPath = urlPath.replace(`{${"paymentProvider"}}`, encodeURIComponent(String(requestParameters['paymentProvider'])));
        urlPath = urlPath.replace(`{${"paymentMethod"}}`, encodeURIComponent(String(requestParameters['paymentMethod'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deactivatePaymentMethodForLocationRaw(requestParameters: DeactivatePaymentMethodForLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deactivatePaymentMethodForLocationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deactivatePaymentMethodForLocation(requestParameters: DeactivatePaymentMethodForLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deactivatePaymentMethodForLocationRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for ensurePaymentMethodForLocation1 without sending the request
     */
    async ensurePaymentMethodForLocation1RequestOpts(requestParameters: EnsurePaymentMethodForLocation1Request): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling ensurePaymentMethodForLocation1().'
            );
        }

        if (requestParameters['paymentProvider'] == null) {
            throw new runtime.RequiredError(
                'paymentProvider',
                'Required parameter "paymentProvider" was null or undefined when calling ensurePaymentMethodForLocation1().'
            );
        }

        if (requestParameters['paymentMethod'] == null) {
            throw new runtime.RequiredError(
                'paymentMethod',
                'Required parameter "paymentMethod" was null or undefined when calling ensurePaymentMethodForLocation1().'
            );
        }

        if (requestParameters['ensurePaymentMethodForLocationRequest'] == null) {
            throw new runtime.RequiredError(
                'ensurePaymentMethodForLocationRequest',
                'Required parameter "ensurePaymentMethodForLocationRequest" was null or undefined when calling ensurePaymentMethodForLocation1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/payment-methods/{paymentProvider}/{paymentMethod}`;
        urlPath = urlPath.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters['locationId'])));
        urlPath = urlPath.replace(`{${"paymentProvider"}}`, encodeURIComponent(String(requestParameters['paymentProvider'])));
        urlPath = urlPath.replace(`{${"paymentMethod"}}`, encodeURIComponent(String(requestParameters['paymentMethod'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EnsurePaymentMethodForLocationRequestToJSON(requestParameters['ensurePaymentMethodForLocationRequest']),
        };
    }

    /**
     */
    async ensurePaymentMethodForLocation1Raw(requestParameters: EnsurePaymentMethodForLocation1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.ensurePaymentMethodForLocation1RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async ensurePaymentMethodForLocation1(requestParameters: EnsurePaymentMethodForLocation1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.ensurePaymentMethodForLocation1Raw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllLocations without sending the request
     */
    async getAllLocationsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllLocationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LocationSearchDto>>> {
        const requestOptions = await this.getAllLocationsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LocationSearchDtoFromJSON));
    }

    /**
     */
    async getAllLocations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LocationSearchDto>> {
        const response = await this.getAllLocationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentMethodCountries without sending the request
     */
    async getPaymentMethodCountriesRequestOpts(requestParameters: GetPaymentMethodCountriesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentProvider'] == null) {
            throw new runtime.RequiredError(
                'paymentProvider',
                'Required parameter "paymentProvider" was null or undefined when calling getPaymentMethodCountries().'
            );
        }

        if (requestParameters['paymentMethod'] == null) {
            throw new runtime.RequiredError(
                'paymentMethod',
                'Required parameter "paymentMethod" was null or undefined when calling getPaymentMethodCountries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-methods/{paymentProvider}/{paymentMethod}/countries`;
        urlPath = urlPath.replace(`{${"paymentProvider"}}`, encodeURIComponent(String(requestParameters['paymentProvider'])));
        urlPath = urlPath.replace(`{${"paymentMethod"}}`, encodeURIComponent(String(requestParameters['paymentMethod'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentMethodCountriesRaw(requestParameters: GetPaymentMethodCountriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PaymentMethodCountryDto>>> {
        const requestOptions = await this.getPaymentMethodCountriesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PaymentMethodCountryDtoFromJSON));
    }

    /**
     */
    async getPaymentMethodCountries(requestParameters: GetPaymentMethodCountriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PaymentMethodCountryDto>> {
        const response = await this.getPaymentMethodCountriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentMethodCountryConnections without sending the request
     */
    async getPaymentMethodCountryConnectionsRequestOpts(requestParameters: GetPaymentMethodCountryConnectionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentProvider'] == null) {
            throw new runtime.RequiredError(
                'paymentProvider',
                'Required parameter "paymentProvider" was null or undefined when calling getPaymentMethodCountryConnections().'
            );
        }

        if (requestParameters['paymentMethod'] == null) {
            throw new runtime.RequiredError(
                'paymentMethod',
                'Required parameter "paymentMethod" was null or undefined when calling getPaymentMethodCountryConnections().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-methods/{paymentProvider}/{paymentMethod}/country-connections`;
        urlPath = urlPath.replace(`{${"paymentProvider"}}`, encodeURIComponent(String(requestParameters['paymentProvider'])));
        urlPath = urlPath.replace(`{${"paymentMethod"}}`, encodeURIComponent(String(requestParameters['paymentMethod'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentMethodCountryConnectionsRaw(requestParameters: GetPaymentMethodCountryConnectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PaymentMethodCountryConnectionDto>>> {
        const requestOptions = await this.getPaymentMethodCountryConnectionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PaymentMethodCountryConnectionDtoFromJSON));
    }

    /**
     */
    async getPaymentMethodCountryConnections(requestParameters: GetPaymentMethodCountryConnectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PaymentMethodCountryConnectionDto>> {
        const response = await this.getPaymentMethodCountryConnectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentMethodDetails without sending the request
     */
    async getPaymentMethodDetailsRequestOpts(requestParameters: GetPaymentMethodDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentProvider'] == null) {
            throw new runtime.RequiredError(
                'paymentProvider',
                'Required parameter "paymentProvider" was null or undefined when calling getPaymentMethodDetails().'
            );
        }

        if (requestParameters['paymentMethod'] == null) {
            throw new runtime.RequiredError(
                'paymentMethod',
                'Required parameter "paymentMethod" was null or undefined when calling getPaymentMethodDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-methods/{paymentProvider}/{paymentMethod}/details`;
        urlPath = urlPath.replace(`{${"paymentProvider"}}`, encodeURIComponent(String(requestParameters['paymentProvider'])));
        urlPath = urlPath.replace(`{${"paymentMethod"}}`, encodeURIComponent(String(requestParameters['paymentMethod'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentMethodDetailsRaw(requestParameters: GetPaymentMethodDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentMethodDetailsDto>> {
        const requestOptions = await this.getPaymentMethodDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentMethodDetailsDtoFromJSON(jsonValue));
    }

    /**
     */
    async getPaymentMethodDetails(requestParameters: GetPaymentMethodDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentMethodDetailsDto> {
        const response = await this.getPaymentMethodDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentMethodLocationConnections without sending the request
     */
    async getPaymentMethodLocationConnectionsRequestOpts(requestParameters: GetPaymentMethodLocationConnectionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentProvider'] == null) {
            throw new runtime.RequiredError(
                'paymentProvider',
                'Required parameter "paymentProvider" was null or undefined when calling getPaymentMethodLocationConnections().'
            );
        }

        if (requestParameters['paymentMethod'] == null) {
            throw new runtime.RequiredError(
                'paymentMethod',
                'Required parameter "paymentMethod" was null or undefined when calling getPaymentMethodLocationConnections().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['locationId'] != null) {
            queryParameters['locationId'] = requestParameters['locationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-methods/{paymentProvider}/{paymentMethod}/location-connections`;
        urlPath = urlPath.replace(`{${"paymentProvider"}}`, encodeURIComponent(String(requestParameters['paymentProvider'])));
        urlPath = urlPath.replace(`{${"paymentMethod"}}`, encodeURIComponent(String(requestParameters['paymentMethod'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentMethodLocationConnectionsRaw(requestParameters: GetPaymentMethodLocationConnectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PaymentMethodLocationConnectionDto>>> {
        const requestOptions = await this.getPaymentMethodLocationConnectionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PaymentMethodLocationConnectionDtoFromJSON));
    }

    /**
     */
    async getPaymentMethodLocationConnections(requestParameters: GetPaymentMethodLocationConnectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PaymentMethodLocationConnectionDto>> {
        const response = await this.getPaymentMethodLocationConnectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentMethodLocations without sending the request
     */
    async getPaymentMethodLocationsRequestOpts(requestParameters: GetPaymentMethodLocationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentProvider'] == null) {
            throw new runtime.RequiredError(
                'paymentProvider',
                'Required parameter "paymentProvider" was null or undefined when calling getPaymentMethodLocations().'
            );
        }

        if (requestParameters['paymentMethod'] == null) {
            throw new runtime.RequiredError(
                'paymentMethod',
                'Required parameter "paymentMethod" was null or undefined when calling getPaymentMethodLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-methods/{paymentProvider}/{paymentMethod}/locations`;
        urlPath = urlPath.replace(`{${"paymentProvider"}}`, encodeURIComponent(String(requestParameters['paymentProvider'])));
        urlPath = urlPath.replace(`{${"paymentMethod"}}`, encodeURIComponent(String(requestParameters['paymentMethod'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentMethodLocationsRaw(requestParameters: GetPaymentMethodLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PaymentMethodLocationDto>>> {
        const requestOptions = await this.getPaymentMethodLocationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PaymentMethodLocationDtoFromJSON));
    }

    /**
     */
    async getPaymentMethodLocations(requestParameters: GetPaymentMethodLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PaymentMethodLocationDto>> {
        const response = await this.getPaymentMethodLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentMethods without sending the request
     */
    async getPaymentMethodsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-methods`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentMethodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PaymentMethodDto>>> {
        const requestOptions = await this.getPaymentMethodsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PaymentMethodDtoFromJSON));
    }

    /**
     */
    async getPaymentMethods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PaymentMethodDto>> {
        const response = await this.getPaymentMethodsRaw(initOverrides);
        return await response.value();
    }

}
